import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../services/AuthService/auth.service';

export const appGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticatedAndTokenValid()) {
    authService.logout();
    return false;
  }

  const userType = authService.getCurrentUserType();
  const currentUrl = state.url;

  if (
    userType === 'FUNC' &&
    (currentUrl.includes('/empresa/edicao/cadastro') ||
      currentUrl.includes('/empresa/cadastro-empresa'))
  ) {
    router.navigate(['/home']);
    return false;
  }

  // const userType = authService.getCurrentUserType();
  // const path = router.url;

  // console.log('AppGuard - Verificando acesso:');
  // console.log('- UserType:', userType);
  // console.log('- Requested Path:', path);

  // const isEmpresaRoute = ['empresa'].some(x => path.includes(x));
  // const isMotoristaRoute = ['motorista-externo', 'motorista', 'externo'].some(
  //   x => path.includes(x)
  // );

  // if (isEmpresaRoute && userType !== 'PJ') {
  //   router.navigate(['/home']);
  //   return;
  // }

  // if (isMotoristaRoute && userType !== 'PF') {
  //   router.navigate(['/home']);
  //   return;
  // }

  return true;
};
